/** Shared public marketplace presentation and the v4 technical classification. */
export const PATENT_FIELDS: string[] = [
    '전기·전자·통신', '기계·금속·재료', '화학·환경·바이오',
    '토목·건축', 'AI·로봇·드론', 'BM·생활·기타'
];

const FIELD_ALIASES: Record<string, string[]> = {
    '반도체': ['전기·전자·통신'],
    '화학·환경·조성물': ['화학·환경·바이오'],
    '화학·환경·소재': ['화학·환경·바이오'],
    '약품·바이오': ['화학·환경·바이오'],
    '바이오·의료': ['화학·환경·바이오'],
    '건축·토목': ['토목·건축'],
    '기계·건축·토목': ['기계·금속·재료', '토목·건축'],
    '로봇·반도체': ['전기·전자·통신', 'AI·로봇·드론'],
    '생활발명': ['BM·생활·기타'],
    '기타': ['BM·생활·기타']
};

export function patentFields(value: string | string[]): string[] {
    const values = (Array.isArray(value) ? value : String(value || '').split(/[,;\n]/)).map((v) => v.trim()).filter(Boolean);
    return Array.from(new Set(values.flatMap((v) => FIELD_ALIASES[v] || [v])));
}

export function classNumbers(value: any, max: number = 45): number[] {
    const values = Array.isArray(value) ? value : [value];
    const numbers = values.flatMap((entry) => {
        const text = String(entry ?? '').trim();
        const labelled = Array.from(text.matchAll(/(\d{1,2})\s*류/g), (m) => Number(m[1]));
        return labelled.length ? labelled : /^[\d,\s]+$/.test(text) ? text.split(/[,\s]+/).filter(Boolean).map(Number) : [];
    });
    return Array.from(new Set(numbers.filter((n) => Number.isInteger(n) && n >= 1 && n <= max))).sort((a, b) => a - b);
}

export function saleMethodLabel(item: any): string {
    const value = [item?.saleMethod, ...(item?.saleMethods || [])].join('/').toUpperCase();
    const license = /LICENSE|LICENSING|라이선|라이센/.test(value) || item?.licenseAvailable === true;
    const transfer = /TRANSFER|BOTH|양도/.test(value);
    if (/BOTH/.test(value) || (license && transfer)) return '양도/라이센싱';
    return license ? '라이센싱' : '양도';
}

export function designatedGoodsText(item: any): string {
    const goods = item?.designatedGoods;
    if (typeof goods === 'string') return goods.trim();
    if (Array.isArray(goods)) return goods.map((entry) => {
        if (typeof entry === 'string') return entry.trim();
        const number = entry?.classNumber ?? entry?.class_number ?? entry?.class;
        const name = entry?.goods ?? entry?.name ?? entry?.products;
        return [number ? String(number).replace(/류$/, '') + '류' : '', Array.isArray(name) ? name.join(', ') : name].filter(Boolean).join(' ');
    }).filter(Boolean).join('\n');
    if (goods && typeof goods === 'object') return Object.entries(goods).map(([key, value]) =>
        key.replace(/류$/, '') + '류 ' + (Array.isArray(value) ? value.join(', ') : String(value || ''))
    ).join('\n');
    return '';
}

/** Matching original SVG filename for each technical category. */
export function fieldSymbol(value: string): string {
    const symbols = ['electrical', 'mechanical', 'chemical', 'architecture', 'robotics', 'lifestyle'];
    return symbols[PATENT_FIELDS.indexOf(patentFields(value)[0])] || 'patent';
}
